const styleOverrides = {
  root: {
    marginLeft: '-9px',
  },
};

export default styleOverrides;
